import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CircularProgress from 'material-ui/CircularProgress';
import CargoDuplicatesTable from './Table';

import { getCargoDuplicates } from 'actions/cargoes/duplicates';
import styles from 'styles/index';

class CargoDuplicatesPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getCargoDuplicates();
    }

    render() {
        return (
            <div id='cargo-duplicates' className='table-page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            cargo editor duplicates
                        </h2>
                        <CargoDuplicatesTable />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        isLogged: state.user.isLogged,
        isLoaded: state.cargoDuplicates.isLoaded,
    }),
    dispatch => bindActionCreators(
        {
            getCargoDuplicates,
        },
        dispatch,
    ),
)(CargoDuplicatesPage);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Duplicates/Page.jsx